import { associateBy } from '@vydaps/gui-commons/records';
import { BatchDomain } from '../model/ct-batch-model';

export const documentClassesByDomain = {
  [BatchDomain.PROOF]: [
    {
      key: '25_Q3_FORDERUNGSAUFSTELLUNG',
      label: 'Forderungsaufstellung',
      group: 'Kostenaufstellungen',
    },
    {
      key: '25_Q3_BEIHILFEBESCHEID',
      label: 'Beihilfebescheid',
      group: 'Kostenaufstellungen',
    },
    {
      key: '25_Q3_KRANKENHAUS_BERICHT',
      label: 'KH-Bericht',
      group: 'Medizinische Dokumente',
    },
    {
      key: '25_Q3_AMBULANTER_BERICHT',
      label: 'Amb. Bericht',
      group: 'Medizinische Dokumente',
    },
    {
      key: '25_Q3_MD_PFLEGEGUTACHTEN',
      label: 'MD-Pflegegutachten',
      group: 'Medizinische Dokumente',
    },
    {
      key: '25_Q3_SONSTIGES_GUTACHTEN',
      label: 'Sonstiges Gutachten',
      group: 'Medizinische Dokumente',
    },
    {
      key: '25_Q3_VERORDNUNG',
      label: 'Verordnung',
      group: 'Medizinische Dokumente',
    },
    {
      key: '25_Q3_AU_BESCHEINIGUNG',
      label: 'AU-Bescheinigung',
      group: 'Medizinische Dokumente',
    },
    {
      key: '25_Q3_ESE',
      label: 'ESE',
      group: 'Medizinische Dokumente',
    },
    {
      key: '25_Q3_EUCON_FRAGEBOGEN',
      label: 'EUCON-Fragebogen',
      group: 'Medizinische Dokumente',
    },
    {
      key: '25_Q3_ERSTELLTES_GUTACHTEN',
      label: 'Erstelltes Gutachten',
      group: 'Medizinische Dokumente',
    },
    {
      key: '25_Q3_AUFTRAGSFORMULAR_PROOF',
      label: 'Auftragsformular PROOF',
      group: 'Schriftverkehr',
    },
    {
      key: '25_Q3_AUFTRAGSFORMULAR_ESE',
      label: 'Auftragsformular ESE',
      group: 'Schriftverkehr',
    },
    {
      key: '25_Q3_AUFTRAGSFORMULAR_ATTEST',
      label: 'Auftragsformular ATTEST',
      group: 'Schriftverkehr',
    },
    {
      key: '25_Q3_SONSTIGER_SCHRIFTVERKEHR',
      label: 'Sonstiger Schriftverkehr',
      group: 'Schriftverkehr',
    },
    {
      key: '25_Q3_FORDERUNGSSCHREIBEN',
      label: 'Forderungsschreiben',
      group: 'Schriftverkehr',
    },
    {
      key: '25_Q3_SCHADENANZEIGE',
      label: 'Schadenanzeige',
      group: 'Schriftverkehr',
    },
    {
      key: '25_Q3_WIDERSPRUCH',
      label: 'Widerspruch',
      group: 'Schriftverkehr',
    },
    {
      key: '25_Q3_RECHNUNG',
      label: 'Rechnung',
      group: 'Abrechnung',
    },
    {
      key: '25_Q3_301ER_DATEN',
      label: '301er Daten',
      group: 'Abrechnung',
    },
    {
      key: '25_Q3_SONSTIGES',
      label: 'Sonstiges',
      group: undefined,
    },
    {
      key: 'UNBEKANNT',
      label: 'Unbekannt',
      group: undefined,
    },
    {
      key: 'BEAUFTRAGUNGSMAIL',
      label: 'Beauftragungsmail',
      group: 'Schriftverkehr',
    },
    {
      key: '25_Q3_ANSCHREIBEN_NACHREICHUNG',
      label: 'Anschreiben Nachreichung',
      group: 'Schriftverkehr',
    },
    {
      key: '25_Q3_VOLLMACHT',
      label: 'Vollmacht',
      group: 'Schriftverkehr',
    },
  ],
} as const satisfies Record<
  BatchDomain,
  { key: string; label: string; group: string | undefined }[]
>;

export type DocumentClass = (typeof documentClassesByDomain)[BatchDomain][number];

export type DocumentClassKey = DocumentClass['key'];

export const classByKey = associateBy(
  Object.values(documentClassesByDomain).flatMap((classes) => classes),
  (documentClass) => documentClass.key,
);
